import type { CreateAxiosDefaults } from 'axios'

export const AxiosDefaultOptions = {
  baseURL: process.env.NEXT_PUBLIC_BASE_URL,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: '' },
} satisfies CreateAxiosDefaults
